import PremiumIcon from "assets/images/components/PremiumIcon";
import ContentBox from "components/ContentBox";
import Table from "components/Table";
import TitleSection from "components/TitleSection";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getPensionPlan } from "utils/api";




const TablesPensionPlan = () => {
  const { t } = useTranslation();
  const [pensionPlan, setPensionPlan] = useState();
  const columns = [
    { label: t("tables.pension-plan.offset"), accessor: "offset", sortable: true, format: "CURRENCY_EUR" },
    { label: t("tables.pension-plan.max_pension_sallary"), accessor: "maxPensionSalary", sortable: true, format: "CURRENCY_EUR" },
  ];
  useEffect(() => {
    getPensionPlan().then(t => setPensionPlan(t))
  }, [])
  return (
    <ContentBox>
      <TitleSection title={t("tables.pension-plan.title")} Icon={PremiumIcon} />
      {pensionPlan && <Table data={pensionPlan} columns={columns} />}
    </ContentBox>

  );
};

export default TablesPensionPlan;
